<template>
  <gj-modal
      size="1000x550"
      :visible.sync="modalVisible"
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>覆盖导入</template>
    <template #content>
      <gj-table
          ref="gjTable"
          :data="tableData"
          :columns="columns"
          :loading="loading"
          :adapt-height="false"
          :height="425"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:op="{ row }">
          <gj-upload
              style="display: inline-block;margin-right: 10px;"
              text="导入"
              :showFileList="false"
              uploadBtnType="text"
              container-type="dateRangeReport"
              :row="row"
              @uploadAfter="uploadAfter"
              :validFileSize="200"
              :acceptType="[FileTypeEnum.CSV, FileTypeEnum.X_CSV, FileTypeEnum.XLS, FileTypeEnum.XLSX, FileTypeEnum.X_XLS]"
          >
          </gj-upload>
          <gj-button type="text">移除</gj-button>
        </template>

      </gj-table>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin, queryMixin} from "@/minxins";
import {FileTypeEnum} from "@/components/upload/enum";
import {dateRangeImport} from "@/api/statistics";

export default {
  name: "cover-import-modal",
  mixins: [modalMixIn, uploadMixin, queryMixin],
  props:{
    tableData:null
  },
  data() {
    return {
      FileTypeEnum,
      loading: false, // 加载
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '140px', options: () => this.marketOption},
        {id: 'reportName', header: '报表名称', field: 'reportName', minWidth: '120px'},
        {id: 'recordMonth', header: '数据月份', field: 'recordMonth', width: '90px', sortable: true},
        {id: 'dateRange', header: '日期范围', field: 'dateRange', width: '220px'},
        {id: 'op', header: '操作', field: 'slot:op', width: '180px'},
      ],
    }
  },
  methods:{
    uploadAfter(attId, data, uploadCb, row) {
      this.loading = true;
      dateRangeImport({
        attachmentId: attId,
        countryCode: row.countryCode,
        marketId: row.marketId,
        recordMonth: row.recordMonth
      })
          .then(res => {
            if (res.code !== 0) {
              this.$gjMessage.error(res.msg);
            } else {
              this.$gjMessage.success('导入成功！');
              this.$gjResetPage();
            }
          }).catch(() => {
        uploadCb('error')
      })
          .complete(() => this.loading = false);
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__footer{
  padding-top: 0!important;
}
</style>